import reframe, { subscription } from 'nike-re-framejs';
import Immutable from 'immutable';

reframe.regSub('ticketus/profile-saved', db => db.getIn(['ticketus', 'profile-saved'], Immutable.Map()));

reframe.regSub('ticketus/device-saved', db => db.getIn(['ticketus', 'device-saved']));

reframe.regSub('ticketus/aliasError', db => db.getIn(['ticketus', 'profile-saved', 'aliasError'], null));

reframe.regSub('ticketus/isAliasSaved', db => db.getIn(['ticketus', 'profile-saved', 'aliasSaved'], false));

export const savedTicketParams$ = subscription(db => db.getIn(['ticketus', 'savedTicket']));
